export default "__VITE_PUBLIC_ASSET__c3ffb9d4__"